module.exports = __webpack_public_path__ + "img/unit-card-status.eae63760.png";